/**
 * 彩种菜单基本信息
 * @type {Array}
 */

const MENUS_ZH = [
    {
        categoryName: "分分彩",
        className: "",
        lotterys: [
            {
                lotteryId: 47,
                name: "泰国60秒",
                flaglot: "tg60s",
                type: "hot",
                uri: "#/lottery/ssc/tg60s/cg"
            },
            {
                lotteryId: 28,
                name: "腾讯分分彩",
                flaglot: "txffc",
                type: "hot",
                uri: "#/lottery/ssc/txffc/cg"
            },
            {
                lotteryId: 29,
                name: "加拿大30秒",
                flaglot: "jnd30m",
                type: "new",
                uri: "#/lottery/ssc/jnd30m/cg"
            },
            {
                lotteryId: 14,
                name: "河内五分彩",
                flaglot: "hn5fc",
                type: "hot",
                uri: "#/lottery/ssc/hn5fc/cg"
            },
            {
                lotteryId: 23,
                name: "泰国秒秒彩",
                flaglot: "mmc",
                type: "new",
                uri: "#/lottery/ssc/mmc/cg"
            },
            {
                lotteryId: 38,
                name: "日本分分彩",
                flaglot: "rbffc",
                type: "new",
                uri: "#/lottery/ssc/rbffc/cg"
            },
            {
                lotteryId: 39,
                name: "西贡分分彩",
                flaglot: "xgffc",
                type: "new",
                uri: "#/lottery/ssc/xgffc/cg"
            },
            {
                lotteryId: 40,
                name: "印尼分分彩",
                flaglot: "ynffc",
                type: "new",
                uri: "#/lottery/ssc/ynffc/cg"
            },
            {
                lotteryId: 46,
                name: "泰国300秒",
                flaglot: "tg300s",
                type: "new",
                uri: "#/lottery/ssc/tg300s/cg"
            },
            {
                lotteryId: 37,
                name: "加拿大3D",
                flaglot: "jnd3d",
                type: "new",
                uri: "#/lottery/ssc/jnd3d/cg"
            },
            {
				lotteryId: 73,
				name: "西贡5分彩",
				flaglot: "xgwfc",
				uri: "#/lottery/ssc/xgwfc/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 77,
				name: "印尼5分彩",
				flaglot: "ynwfc",
				uri: "#/lottery/ssc/ynwfc/cg",
				order: 0,
				type: ""
            },
            {
				lotteryId: 71,
				name: "QQ分分彩",
				flaglot: "qq1fc",
				uri: "#/lottery/ssc/qq1fc/cg",
				order: 0,
				type: ""
			}
        ]
    },
    {
        categoryName: "时时彩/基诺彩",
        className: "",
        lotterys: [
            {
                lotteryId: 1,
                name: "重庆时时彩",
                flaglot: "cqssc",
                type: "hot",
                uri: "#/lottery/ssc/cqssc/cg"
            },
            {
                lotteryId: 6,
                name: "新疆时时彩",
                flaglot: "xjssc",
                type: "",
                uri: "#/lottery/ssc/xjssc/cg"
            },
            {
                lotteryId: 13,
                name: "天津时时彩",
                flaglot: "tjssc",
                type: "",
                uri: "#/lottery/ssc/tjssc/cg"
            },
            // {
            //     lotteryId: 15,
            //     name: "江苏快三",
            //     flaglot: "jsk3",
            //     type: "",
            //     uri: "#/lottery/ssc/jsk3/cg"
            // },
            {
                lotteryId: 9,
                name: "北京快乐8",
                flaglot: "bjkl8",
                type: "",
                uri: "#/lottery/ssc/bjkl8/cg"
            }
        ]
    },
    {
        categoryName: "PK10/赛马",
        className: "",
        lotterys: [
            {
                lotteryId: 24,
                name: "北京PK10",
                flaglot: "pk10",
                type: "new",
                uri: "#/lottery/animate/pk10/1"
            },
            {
                lotteryId: 34,
                name: "意大利PK10",
                flaglot: "ydl10",
                type: "new",
                uri: "#/lottery/animate/ydl10/1"
            },
            {
                lotteryId: 33,
                name: "众合PK10",
                flaglot: "zh10",
                type: "new",
                uri: "#/lottery/animate/zh10/1"
            },
            {
                lotteryId: 25,
                name: "新西兰赛马",
                flaglot: "jssm",
                type: "new",
                uri: "#/lottery/animate/jssm/1"
            },
            {
				lotteryId: 75,
				name: "印尼分分PK10",
				flaglot: "ynpk10ff",
				uri: "#/lottery/ssc/ynpk10ff/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 76,
				name: "印尼五分PK10",
				flaglot: "ynpk10wf",
				uri: "#/lottery/ssc/ynpk10wf/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 69,
				name: "极速赛车",
				flaglot: "jssc",
				uri: "#/lottery/ssc/jssc/cg",
				order: 0,
				type: ""
			}
        ]
    },
    {
        categoryName: "11选5",
        className: "",
        lotterys: [
            {
                lotteryId: 8,
                name: "广东11选5",
                flaglot: "gd11x5",
                type: "",
                uri: "#/lottery/ssc/gd11x5/cg"
            },
            {
                lotteryId: 7,
                name: "江西11选5",
                flaglot: "jx11x5",
                type: "",
                uri: "#/lottery/ssc/jx11x5/cg"
            },
            {
                lotteryId: 5,
                name: "山东11选5",
                flaglot: "sd11x5",
                type: "",
                uri: "#/lottery/ssc/sd11x5/cg"
            },
            {
                lotteryId: 30,
                name: "上海11选5",
                flaglot: "sh11x5",
                type: "",
                uri: "#/lottery/ssc/sh11x5/cg"
            },
            {
                lotteryId: 31,
                name: "安徽11选5",
                flaglot: "ah11x5",
                type: "",
                uri: "#/lottery/ssc/ah11x5/cg"
            },
            {
                lotteryId: 35,
                name: "加拿大11选5",
                flaglot: "jnd11x5",
                type: "new",
                uri: "#/lottery/ssc/jnd11x5/cg"
            },
            {
                lotteryId: 48,
                name: "泰国11选5",
                flaglot: "tg11x5",
                type: "new",
                uri: "#/lottery/ssc/tg11x5/cg"
            },
            {
				lotteryId: 64,
				name: "广西11选5",
				flaglot: "gx11x5",
				uri: "#/lottery/ssc/gx11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 66,
				name: "黑龙江11选5",
				flaglot: "hlj11x5",
				uri: "#/lottery/ssc/hlj11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 65,
				name: "湖北11选5",
				flaglot: "hb11x5",
				uri: "#/lottery/ssc/hb11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 70,
				name: "辽宁11选5",
				flaglot: "ln11x5",
				uri: "#/lottery/ssc/ln11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 72,
				name: "泰国分分11选5",
				flaglot: "tg11x5ff",
				uri: "#/lottery/ssc/tg11x5ff/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 74,
				name: "云南11选5",
				flaglot: "yn11x5",
				uri: "#/lottery/ssc/yn11x5/cg",
				order: 0,
				type: ""
			}
        ],
    },
    {
        categoryName: "低频彩",
        className: "",
        lotterys: [
            {
                lotteryId: 20,
                name: "香港六合彩",
                flaglot: "xglhc",
                type: "",
                uri: "#/lottery/lhc/xglhc/1"
            },
            {
                lotteryId: 11,
                name: "3D福彩",
                flaglot: "3dfc",
                type: "",
                uri: "#/lottery/ssc/3dfc/cg"
            },
            {
                lotteryId: 12,
                name: "排列3",
                flaglot: "pl3",
                type: "",
                uri: "#/lottery/ssc/pl3/cg"
            },
            {
				lotteryId: 67,
				name: "河南快三",
				flaglot: "hnks",
				uri: "#/lottery/ssc/hnks/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 68,
				name: "吉林快三",
				flaglot: "jlks",
				uri: "#/lottery/ssc/jlks/cg",
				order: 0,
				type: ""
			}
        ]
    }
]
const MENUS_HY = [
    {
        categoryName: "热门分分彩",
        className: "",
        lotterys: [
            {
                lotteryId: 14,
                name: "河内五分彩",
                flaglot: "hn5fc",
                type: "hot",
                uri: "#/lottery/ssc/hn5fc/cg"
            },
            {
                lotteryId: 42,
                name: "多彩腾讯30秒",
                flaglot: "tx30s",
                type: "hot",
                uri: "#/lottery/ssc/tx30s/cg"
            },
            {
                lotteryId: 19,
                name: "河内1分彩",
                flaglot: "hn1fc",
                type: "hot",
                uri: "#/lottery/ssc/hn1fc/cg",
                order: 5
            },
            {
                lotteryId: 41,
                name: "多彩重庆30秒",
                flaglot: "cq30s",
                type: "hot",
                uri: "#/lottery/ssc/cq30s/cg"
            },
            {
                lotteryId: 28,
                name: "腾讯分分彩",
                flaglot: "txffc",
                type: "hot",
                uri: "#/lottery/ssc/txffc/cg"
            },
            {
                lotteryId: 29,
                name: "加拿大30秒",
                flaglot: "jnd30m",
                type: "hot",
                uri: "#/lottery/ssc/jnd30m/cg"
            },
            {
				lotteryId: 36,
				name: "多彩腾讯分分彩",
				flaglot: "qqffc",
				type: "hot",
				uri: "#/lottery/ssc/qqffc/cg"
            },
            {
                lotteryId: 23,
                name: "泰国秒秒彩",
                flaglot: "mmc",
                type: "",
                uri: "#/lottery/ssc/mmc/cg"
            },
            {
                lotteryId: 51,
                name: "腾讯2分彩(单)",
                flaglot: "txdsq",
                type: "new",
                uri: "#/lottery/ssc/txdsq/cg"
            },
            {
                lotteryId: 47,
                name: "泰国60秒",
                flaglot: "tg60s",
                type: "hot",
                uri: "#/lottery/ssc/tg60s/cg"
            },
            {
                lotteryId: 52,
                name: "腾讯2分彩(双)",
                flaglot: "txssq",
                type: "new",
                uri: "#/lottery/ssc/txssq/cg"
            },
            {
                lotteryId: 46,
                name: "泰国300秒",
                flaglot: "tg300s",
                type: "",
                uri: "#/lottery/ssc/tg300s/cg"
            },
            {
                lotteryId: 53,
                name: "腾讯5分彩",
                flaglot: "txwfc",
                type: "new",
                uri: "#/lottery/ssc/txwfc/cg"
            },
            {
				lotteryId: 73,
				name: "西贡5分彩",
				flaglot: "xgwfc",
				uri: "#/lottery/ssc/xgwfc/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 77,
				name: "印尼5分彩",
				flaglot: "ynwfc",
				uri: "#/lottery/ssc/ynwfc/cg",
				order: 0,
				type: ""
            },
            {
				lotteryId: 2,
				name: "支付宝5分彩",
				flaglot: "zfb5fc",
				uri: "#/lottery/ssc/zfb5fc/cg",
				order: 0,
				type: ""
            },
            {
				lotteryId: 97,
				name: "比特币分分彩",
				flaglot: "btcffc",
				uri: "#/lottery/ssc/btcffc/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 32,
				name: "支付宝分分彩",
				flaglot: "zfbffc",
				uri: "#/lottery/ssc/zfbffc/cg",
				order: 0,
				type: ""
			},
        ]
    },
    {
        categoryName: "高频分分彩",
        className: "",
        lotterys: [
            // {
            //     lotteryId: 58,
            //     name: "私营腾讯分分彩",
            //     flaglot: "sytxffc",
            //     type: "",
            //     uri: "#/lottery/ssc/sytxffc/cg",
            // },
            {
				lotteryId: 78,
				name: "奇趣腾讯分分",
				flaglot: "syqiqu",
				type: "new",
				uri: "#/lottery/ssc/syqiqu/cg",
			},
            {
                lotteryId: 26,
                name: "瑞典1分彩",
                flaglot: "rd1fc",
                type: "",
                uri: "#/lottery/ssc/rd1fc/cg",
                order: 7
            },

            {
                lotteryId: 27,
                name: "瑞典2分彩",
                flaglot: "rd2fc",
                type: "",
                uri: "#/lottery/ssc/rd2fc/cg",
                order: 8
            },
            {
                lotteryId: 39,
                name: "西贡分分彩",
                flaglot: "xgffc",
                type: "",
                uri: "#/lottery/ssc/xgffc/cg"
            },
            {
                lotteryId: 38,
                name: "日本分分彩",
                flaglot: "rbffc",
                type: "",
                uri: "#/lottery/ssc/rbffc/cg"
            },
            {
                lotteryId: 40,
                name: "印尼分分彩",
                flaglot: "ynffc",
                type: "",
                uri: "#/lottery/ssc/ynffc/cg"
            },
            {
				lotteryId: 71,
				name: "QQ分分彩",
				flaglot: "qq1fc",
				uri: "#/lottery/ssc/qq1fc/cg",
				order: 0,
				type: ""
			}
        ]
    },
    {
        categoryName: "PK10/赛马",
        className: "",
        lotterys: [
			{
                lotteryId: 50,
                name: "幸运飞艇",
                flaglot: "xyft",
                type: "new",
                uri: "#/lottery/animate/xyft/1"
            },
            {
                lotteryId: 24,
                name: "北京PK10",
                flaglot: "pk10",
                type: "hot",
                uri: "#/lottery/animate/pk10/1"
            },
            {
                lotteryId: 34,
                name: "意大利PK10",
                flaglot: "ydl10",
                type: "hot",
                uri: "#/lottery/animate/ydl10/1"
            },
            {
                lotteryId: 25,
                name: "新西兰赛马",
                flaglot: "jssm",
                type: "",
                uri: "#/lottery/animate/jssm/1"
            },
            {
				lotteryId: 75,
				name: "印尼分分PK10",
				flaglot: "ynpk10ff",
				uri: "#/lottery/ssc/ynpk10ff/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 76,
				name: "印尼五分PK10",
				flaglot: "ynpk10wf",
				uri: "#/lottery/ssc/ynpk10wf/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 69,
				name: "极速赛车",
				flaglot: "jssc",
				uri: "#/lottery/ssc/jssc/cg",
				order: 0,
				type: ""
			}
        ]
    },
    {
        categoryName: "经典时时彩",
        className: "",
        lotterys: [
            {
                lotteryId: 1,
                name: "重庆时时彩",
                flaglot: "cqssc",
                type: "hot",
                uri: "#/lottery/ssc/cqssc/cg"
            },
            {
                lotteryId: 6,
                name: "新疆时时彩",
                flaglot: "xjssc",
                type: "",
                uri: "#/lottery/ssc/xjssc/cg"
            },
            {
                lotteryId: 13,
                name: "天津时时彩",
                flaglot: "tjssc",
                type: "",
                uri: "#/lottery/ssc/tjssc/cg"
            },

            // {
            //     lotteryId: 15,
            //     name: "江苏快三",
            //     flaglot: "jsk3",
            //     type: "",
            //     uri: "#/lottery/ssc/jsk3/cg"
            // },
            // {
            //     lotteryId: 9,
            //     name: "北京快乐8",
            //     flaglot: "bjkl8",
            //     type: "",
            //     uri: "#/lottery/ssc/bjkl8/cg"
            // }
        ]
    },
    {
        categoryName: "11选5",
        className: "",
        lotterys: [
            {
                lotteryId: 8,
                name: "广东11选5",
                flaglot: "gd11x5",
                type: "hot",
                uri: "#/lottery/ssc/gd11x5/cg"
            },
            {
                lotteryId: 48,
                name: "泰国11选5",
                flaglot: "tg11x5",
                type: "",
                uri: "#/lottery/ssc/tg11x5/cg"
            },
            {
                lotteryId: 7,
                name: "江西11选5",
                flaglot: "jx11x5",
                type: "",
                uri: "#/lottery/ssc/jx11x5/cg"
            },
            {
                lotteryId: 35,
                name: "加拿大11选5",
                flaglot: "jnd11x5",
                type: "",
                uri: "#/lottery/ssc/jnd11x5/cg"
            },
            {
                lotteryId: 5,
                name: "山东11选5",
                flaglot: "sd11x5",
                type: "",
                uri: "#/lottery/ssc/sd11x5/cg"
            },
            {
				lotteryId: 64,
				name: "广西11选5",
				flaglot: "gx11x5",
				uri: "#/lottery/ssc/gx11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 66,
				name: "黑龙江11选5",
				flaglot: "hlj11x5",
				uri: "#/lottery/ssc/hlj11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 65,
				name: "湖北11选5",
				flaglot: "hb11x5",
				uri: "#/lottery/ssc/hb11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 70,
				name: "辽宁11选5",
				flaglot: "ln11x5",
				uri: "#/lottery/ssc/ln11x5/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 72,
				name: "泰国分分11选5",
				flaglot: "tg11x5ff",
				uri: "#/lottery/ssc/tg11x5ff/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 74,
				name: "云南11选5",
				flaglot: "yn11x5",
				uri: "#/lottery/ssc/yn11x5/cg",
				order: 0,
				type: ""
			}
            // {
            //     lotteryId: 30,
            //     name: "上海11选5",
            //     flaglot: "sh11x5",
            //     type: "",
            //     uri: "#/lottery/ssc/sh11x5/cg"
            // },
            // {
            //     lotteryId: 31,
            //     name: "安徽11选5",
            //     flaglot: "ah11x5",
            //     type: "",
            //     uri: "#/lottery/ssc/ah11x5/cg"
            // },
        ],
    },
    {
        categoryName: "3D/P3",
        className: "",
        lotterys: [
            // {
            //     lotteryId: 20,
            //     name: "香港六合彩",
            //     flaglot: "xglhc",
            //     type: "",
            //     uri: "#/lottery/lhc/xglhc/1"
            // },
            // {
            //     lotteryId: 11,
            //     name: "3D福彩",
            //     flaglot: "3dfc",
            //     type: "",
            //     uri: "#/lottery/ssc/3dfc/cg"
            // },
            {
                lotteryId: 12,
                name: "排列3",
                flaglot: "pl3",
                type: "",
                uri: "#/lottery/ssc/pl3/cg"
            },
            {
                lotteryId: 37,
                name: "加拿大3D",
                flaglot: "jnd3d",
                type: "hot",
                uri: "#/lottery/ssc/jnd3d/cg"
            },
            {
				lotteryId: 67,
				name: "河南快三",
				flaglot: "hnks",
				uri: "#/lottery/ssc/hnks/cg",
				order: 0,
				type: ""
			},
			{
				lotteryId: 68,
				name: "吉林快三",
				flaglot: "jlks",
				uri: "#/lottery/ssc/jlks/cg",
				order: 0,
				type: ""
			}
        ]
    }
]
const MENUS_DF = [
    {
        categoryName: "分分彩",
        className: "",
        lotterys: [
            {
                lotteryId: 28,
                name: "腾讯分分彩",
                flaglot: "txffc",
                type: "",
                uri: "#/lottery/ssc/txffc/cg"
            },
          {
            lotteryId: 40,
            name: "印尼分分彩",
            flaglot: "ynffc",
            type: "",
            uri: "#/lottery/ssc/ynffc/cg"
          }
        ]
    },
    {
        categoryName: "时时彩/基诺彩",
        className: "",
        lotterys: [
            {
                lotteryId: 1,
                name: "重庆时时彩",
                flaglot: "cqssc",
                type: "",
                uri: "#/lottery/ssc/cqssc/cg"
            },
              {
                lotteryId: 9,
                name: "北京快乐8",
                flaglot: "bjkl8",
                type: "",
                uri: "#/lottery/ssc/bjkl8/cg"
              }
        ]
    },
    {
        categoryName: "PK10/赛马",
        className: "",
        lotterys: [
            {
                lotteryId: 24,
                name: "北京PK10",
                flaglot: "pk10",
                type: "",
                uri: "#/lottery/animate/pk10/1"
            }
        ]
    },
    {
        categoryName: "11选5",
        className: "",
        lotterys: [
            {
                lotteryId: 8,
                name: "广东11选5",
                flaglot: "gd11x5",
                type: "",
                uri: "#/lottery/ssc/gd11x5/cg"
            },
            {
                lotteryId: 5,
                name: "山东11选5",
                flaglot: "sd11x5",
                type: "",
                uri: "#/lottery/ssc/sd11x5/cg"
            },
            {
                lotteryId: 31,
                name: "安徽11选5",
                flaglot: "ah11x5",
                type: "",
                uri: "#/lottery/ssc/ah11x5/cg"
            }
        ],
    },
    {
        categoryName: "低频彩",
        className: "",
        lotterys: [
            {
                lotteryId: 11,
                name: "3D福彩",
                flaglot: "3dfc",
                type: "",
                uri: "#/lottery/ssc/3dfc/cg"
            },
            {
                lotteryId: 12,
                name: "排列3",
                flaglot: "pl3",
                type: "",
                uri: "#/lottery/ssc/pl3/cg"
            }
        ]
    }
]

var MENUS;
switch(window.vers){
    case 'hy':  // 恒耀
        MENUS = MENUS_HY;
        break;
    case 'zh':  // 众合
        MENUS = MENUS_ZH;
        break;
    case 'df':  // 达福
        MENUS = MENUS_DF;
        break;
    default:
        MENUS = MENUS_HY;
}
export const LOTTERY_MENUS = MENUS;
